import http from "./httpService";

export function getEmailVerify1(user) {
  const apiEndpoint = "/peoples";

  return http.get(apiEndpoint + "/" + user.codigo + "/" + user.telemovel);
}
